import { useMemo } from 'react';

import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

import { filterRecommendedAssets, filterAvailableAssets } from '../utils/assetFilters';

interface UseAssetFilteringParams {
  recommendedAssets: RecommendedAsset[];
  availableAssets: AssetItem[];
  search: string;
  importance: string;
}

interface UseAssetFilteringReturn {
  filteredRecommended: RecommendedAsset[];
  filteredOthers: AssetItem[];
}

/**
 * Custom hook for filtering assets based on search term and importance
 */
const useAssetFiltering = ({
  recommendedAssets,
  availableAssets,
  search,
  importance,
}: UseAssetFilteringParams): UseAssetFilteringReturn => {
  const filteredRecommended = useMemo(
    () => filterRecommendedAssets(recommendedAssets, search, importance),
    [recommendedAssets, search, importance],
  );

  const filteredOthers = useMemo(
    () => filterAvailableAssets(availableAssets, filteredRecommended, search, importance),
    [availableAssets, filteredRecommended, search, importance],
  );

  return {
    filteredRecommended,
    filteredOthers,
  };
};

export default useAssetFiltering;
